// extracted by mini-css-extract-plugin
export default {"MONTH":"M9kpUR","month":"M9kpUR","DAY":"Rh_KKx","day":"Rh_KKx","YEAR":"RCkJXd","year":"RCkJXd","fields":"ulMKdt","mobile":"J4cKwQ"};